// 土地使用许可证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let land = get(state, 'currentShopBaseDetail.docInfo.land', {})
  return {
    title: i18n.gettext('土地使用许可证'),
    content: [
      // {
      //   title: i18n.gettext('餐厅名称'),
      //   label: land.resName
      // },
      // {
      //   title: i18n.gettext('餐厅地址'),
      //   label: land.resAddr
      // },
      // {
      //   title: i18n.gettext('许可证编号'),
      //   label: land.licenseNum
      // },
      // {
      //   title: i18n.gettext('土地用途'),
      //   label: land.use
      // },
      // {
      //   title: i18n.gettext('有效期'),
      //   content: land.validateDate
      // },
      {
        title: i18n.gettext('土地使用许可证执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: land.licensePics
      }
    ]
  }
}
